var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.23163C14.6663 10.0978 11.8563 12.4576 7.61753 12.4576C7.54181 12.4576 7.46609 12.4519 7.39032 12.4462L7.38827 12.446C7.30595 12.446 7.22367 12.4748 7.12374 12.5439C6.12431 13.246 4.36652 14 3.66105 14C3.20838 14 3.07904 13.6374 3.30832 13.3497C3.37408 13.2649 3.47161 13.1501 3.58466 13.017C3.85559 12.6979 4.21659 12.2728 4.44883 11.8993C4.49586 11.813 4.46646 11.7266 4.37828 11.6806C2.49115 10.6906 1.33301 9.07336 1.33301 7.23163C1.33301 4.33669 4.29597 2 7.9997 2C11.7034 2 14.6663 4.33669 14.6663 7.23163Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/ChatMessage.489e3ecebcc962744707ed3fff3f81be.svg";
export { ForwardRef as ReactComponent };